import client from "./client";

export function getSchedules(
  year = null,
  month = null,
  schedule_type_id = null,
) {
  let params = [];
  if (year !== null) params.year = year;
  if (month !== null) params.month = month;
  if (schedule_type_id !== null) params.schedule_type_id = schedule_type_id;
  params = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join("&");
  params = params ? `?${params}` : "";
  return client.get(`/api/schedules/${params}`).then((res) => res.data);
}

export function addSchedule(body) {
  return client.post("/api/schedules/", body).then((res) => res.data);
}

export function setSchedule(body) {
  return client.put(`/api/schedules/${body.id}/`, body).then((res) => res.data);
}

export function deleteSchedule(body) {
  return client.delete(`/api/schedules/${body.id}/`).then((res) => res.data);
}

export function getOnDutyFrequency(year = null, month = null) {
  if (!year || !month) return null;
  const params = year && month ? `?year=${year}&month=${month}` : "";
  return client.get(`/api/on_duty_frequency/${params}`).then((res) => res.data);
}

export function bulkConfirm(year = null, month = null) {
  if (!year || !month) return null;
  const data = { year: year, month: month };
  return client.post("/api/bulk_confirm/", data).then((res) => res.data);
}
